import styled from 'styled-components'

export const VSMHeroImgStyles = styled.div`
	#customerIcon {
		#customer {
			transform-origin: 50% 50%;
			transition: transform 0.2s ease;
		}

		&:hover {
			#customer {
				transform: scale(1.1);
			}
		}
	}
	#optimizeIcon {
		#optimize {
			transform-origin: 95% 50%;
			transition: transform 0.2s ease;
		}

		&:hover {
			#optimize {
				transform: scale(1.1);
			}
		}
	}
	#measureIcon {
		#measure {
			transform-origin: 5% 50%;
			transition: transform 0.2s ease;
		}

		&:hover {
			#measure {
				transform: scale(1.1);
			}
		}
	}
	#ideateIcon {
		#ideate {
			transform-origin: 25% 25%;
			transition: transform 0.2s ease;
		}

		&:hover {
			#ideate {
				transform: scale(1.1);
			}
		}
	}
	#createIcon {
		#create {
			transform-origin: 25% 75%;
			transition: transform 0.2s ease;
		}

		&:hover {
			#create {
				transform: scale(1.1);
			}
		}
	}
	#operateIcon {
		#operate {
			transform-origin: 75% 25%;
			transition: transform 0.2s ease;
		}

		&:hover {
			#operate {
				transform: scale(1.1);
			}
		}
	}
	#releaseIcon {
		#release {
			transform-origin: 75% 75%;
			transition: transform 0.2s ease;
		}

		&:hover {
			#release {
				transform: scale(1.1);
			}
		}
	}
`
